import {pick} from "lodash"

import {
  ASaasCompanyUser,
  ASaasSalesPerson,
  ASettings,
  AUsersCompanyUser,
  AUsersSalesPerson,
  AUserTypes,
} from "../services/types.generated"

export const isCompanyUser = (user: ASettings["user"]): user is AUsersCompanyUser => {
  return user.type === AUserTypes.CompanyUser && "company" in user
}

export const isAdminUser = (user: ASettings["user"]): boolean => {
  return user.type === AUserTypes.Admin
}

export const isSaaSCompanyUser = (user: ASettings["user"]): user is ASaasCompanyUser => {
  return user.type === AUserTypes.SaasCompanyUser && "company" in user
}

export const isSaaSSalespersonUser = (user: ASettings["user"]): user is ASaasSalesPerson => {
  return user.type === AUserTypes.SaasSalesPerson
}

export const isSalesPersonUser = (user: ASettings["user"]): user is AUsersSalesPerson => {
  return user.type === AUserTypes.SalesPerson
}

export type TPickPropsShape<T extends Record<any, any>> = {[prop in keyof Required<T>]: true}

export function pickProps<T extends Record<any, any>>(shape: TPickPropsShape<T>) {
  return (allProps: T & Record<any, any>) => pick(allProps, Object.keys(shape)) as unknown as T
}
